/* search-scope.js — narrows storefront search to the fields that actually
   describe a product.

   Shopify's product index includes the description body, so a search for
   "Lincoln" returns every print whose blurb happens to name him — Mount
   Rushmore ("Washington, Jefferson, Roosevelt, and Lincoln"), I Have a Dream
   ("the Lincoln Memorial"), and ~150 others. The `options[fields]` request
   param is silently ignored, but field-scoped `q` syntax is honoured, so we
   rewrite the query on submit:

     Lincoln    ->  (title:Lincoln OR tag:Lincoln OR product_type:Lincoln)
     Civil War  ->  (title:Civil OR ...) AND (title:War OR ...)

   Per-word AND (rather than a quoted phrase) keeps "lincoln abraham" working.
   Without JS the form submits the raw term and search behaves as it does today. */
(function () {
  'use strict';

  var FIELDS = ['title', 'tag', 'product_type'];
  // Operators and grouping characters that would otherwise be parsed as syntax.
  var RESERVED = /^(AND|OR|NOT)$/i;
  var STRIP = /[():"*~^\\]/g;

  function words(raw) {
    return String(raw)
      .split(/\s+/)
      .map(function (w) {
        // A leading "-" reads as negation to Shopify; a trailing one is noise.
        return w.replace(STRIP, '').replace(/^-+/, '').replace(/-+$/, '');
      })
      .filter(function (w) { return w.length > 0 && !RESERVED.test(w); });
  }

  /* Build the scoped query. `wildcard` appends * to each word for prefix
     matching ("linco" -> "linco*"), used as a predictive-search fallback.
     Returns '' when there's nothing safe to scope — callers then use the raw
     term rather than submitting a broken query. */
  function build(raw, wildcard) {
    var ws = words(raw);
    if (!ws.length) return '';
    return ws
      .map(function (w) {
        var term = wildcard ? w + '*' : w;
        return '(' + FIELDS.map(function (f) { return f + ':' + term; }).join(' OR ') + ')';
      })
      .join(' AND ');
  }

  /* A term the shopper typed themselves (already contains field syntax, an
     operator, or a quoted phrase) is passed through untouched — they know
     what they're doing, and re-scoping it would corrupt it. */
  function isAlreadyScoped(raw) {
    return /[:"]/.test(raw) || /\b(AND|OR|NOT)\b/.test(raw);
  }

  function scopeForm(form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var raw = input.value.trim();
      if (!raw || isAlreadyScoped(raw)) return;
      var scoped = build(raw, false);
      if (!scoped) return;
      input.value = scoped;
      // The form serialises synchronously, so putting the human term back on
      // the next tick keeps the raw text in the box if the page is restored
      // from bfcache instead of leaving the scoped expression on screen.
      setTimeout(function () { input.value = raw; }, 0);
    });
  }

  function init() {
    document.querySelectorAll('form[role="search"]').forEach(scopeForm);
  }

  window.theme = window.theme || {};
  window.theme.searchScope = { build: build, words: words, isAlreadyScoped: isAlreadyScoped };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
